import { ActionIcon, FileButton, Text } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import { useFormContext } from "react-hook-form";
import { Button } from "src/components/shared/Button/Button";
import { useTheme } from "src/hooks";
import { Flex } from "src/styled";
import { deepClone, fileToBase64, openBase64 } from "src/utils";

import { StyledFileFlex } from "./MultipleAttachments.styled";
export interface IInEntryFile {
  filename: string;
  filetype: string;
  b64: string;
}
interface Props {
  id: string;
  value: IInEntryFile[];
  btnText?: string;
}
const MultipleAttachments = ({ id, value, btnText }: Props) => {
  useTheme();
  const { setValue } = useFormContext();

  const handleSetFile = async (file: File) => {
    const filename = file.name;
    const filetype = file.type === "application/pdf" ? "pdf" : "jpg";
    const b64 = await fileToBase64(file);
    setValue(id, [...value, { filename, filetype, b64 }]);
  };

  const handleOpenFile = (file: IInEntryFile) => {
    openBase64(file.b64, file.filetype, file.filename, false);
  };

  const handleDeleteFile = (e: any, index: number) => {
    e.preventDefault();
    e.stopPropagation();
    const newValue = deepClone(value);
    newValue.splice(index, 1);
    setValue(id, newValue);
  };

  return (
    <Flex direction="column" gap={7}>
      <FileButton
        onChange={handleSetFile}
        accept="image/png,image/jpeg,application/pdf">
        {props => (
          <Button w="min-content" variant="outline" {...props}>
            {btnText ?? "Add Report"}
          </Button>
        )}
      </FileButton>
      <Flex gap={4} wrap="wrap">
        {value.map(
          (file, index) =>
            file.filename &&
            file.b64 && (
              <StyledFileFlex
                key={`file-${index}`}
                onClick={() => handleOpenFile(file)}>
                <Text>{file.filename}</Text>
                <ActionIcon
                  onClick={e => handleDeleteFile(e, index)}
                  color="red">
                  <IconTrash />
                </ActionIcon>
              </StyledFileFlex>
            ),
        )}
      </Flex>
    </Flex>
  );
};
export default MultipleAttachments;
